// extracted by mini-css-extract-plugin
export default {"setting":"LocalLoginSettingsToggles_setting__-nVoV","setting__description":"LocalLoginSettingsToggles_setting__description__JOjWQ"};